import React, { Component, PureComponent, Fragment } from 'react'
import { Form, Button } from 'semantic-ui-react'
import Upload from '../../file/upload'

export default class FileUrlInput extends Component {
  state = {
    open: false,
  }

  render() {
    let inputClasses = ['form-input', 'form-input--text']
    let { open } = this.state

    let {
      type,
      formState,
      tags,
      options,
      inputLabel,
      referenceConfig,
      access = false,
      fileType = ['image'],
      ...inputProps
    } = this.props
    let { name, onChange } = inputProps

    return (
      <div className="form-file-url">
        <Form.Input {...inputProps} type="text" className={inputClasses.join(' ')} />
        <div className="form-field-url-button">
          <Button
            content={open ? 'Sulje' : 'Lataa'}
            icon={open ? 'times' : 'upload'}
            color="green"
            size="tiny"
            onClick={e => e.preventDefault() & this.setState({ open: open === false })}
          />
        </div>
        {open ? (
          <Upload
            access={access}
            selectOnMount
            type={fileType}
            onSingleUploadSuccess={file => {
              onChange({ name, value: file.url })
              this.setState({
                open: false,
              })
            }}
          />
        ) : null}
      </div>
    )
  }
}
